/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Eon Account Status.
*/
export enum EonAccountStatus {
  EON_ACCOUNT_STATUS_UNSPECIFIED = 'UNSPECIFIED',
  EON_ACCOUNT_STATUS_ACTIVE = 'ACTIVE',
  EON_ACCOUNT_STATUS_ONBOARDING = 'ONBOARDING',
  EON_ACCOUNT_STATUS_REGISTRATION = 'REGISTRATION',
  EON_ACCOUNT_STATUS_INACTIVE = 'INACTIVE'
}
